import de from './de.json';
import en from './en.json';

export const locales = {
  de,
  en
};

export default locales;
